import { FC } from "react";
import { FamilyMemberFormType } from "@utils/patientFormHelper";
import { Avatar, Checkbox, Stack } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import StyledLink from "@components/StyledLink/StyledLink";
import { formatName } from "@utils/formatting.util";

export interface FamilyMemberRowProps {
  selected: boolean;
  familyMember: FamilyMemberFormType;
  onSelect: () => void;
  onEdit: () => void;
  onRemove: () => void;
  avatarUrl?: string;
}

const FamilyMemberRow: FC<FamilyMemberRowProps> = ({
  familyMember,
  selected,
  onSelect,
  onEdit,
  avatarUrl,
}) => {
  return (
    <TableRow>
      <TableCell scope="row">
        <Checkbox checked={selected} onClick={onSelect} />
      </TableCell>
      <TableCell>
        <StyledLink to={""} onClick={(e) => e.preventDefault()}>
          <div onClick={onEdit}>
            <Stack flexDirection="row" gap="16px" alignItems="center">
              <Avatar src={avatarUrl} />
              {formatName(familyMember)}
            </Stack>
          </div>
        </StyledLink>
      </TableCell>
      <TableCell>
        {familyMember.relation} - {familyMember.relationTo}
      </TableCell>
    </TableRow>
  );
};

export default FamilyMemberRow;
